// Add Availability

export const ADD_AVAILABILITY_REQUEST = 'ADD_AVAILABILITY_REQUEST';
export const ADD_AVAILABILITY_SUCCESS = 'ADD_AVAILABILITY_SUCCESS';
export const ADD_AVAILABILITY_FAILURE = 'ADD_AVAILABILITY_FAILURE';

// Get Conflicted Availability

export const GET_CONFLICTED_AVAILABILITY_REQUEST = 'GET_CONFLICTED_AVAILABILITY_REQUEST';
export const GET_CONFLICTED_AVAILABILITY_SUCCESS = 'GET_CONFLICTED_AVAILABILITY_SUCCESS';
export const GET_CONFLICTED_AVAILABILITY_FAILURE = 'GET_CONFLICTED_AVAILABILITY_FAILURE';

// Remove conflicted Availability

export const REMOVE_CONFLICTED_AVAILABILITY_REQUEST = 'REMOVE_CONFLICTED_AVAILABILITY_REQUEST';
export const REMOVE_CONFLICTED_AVAILABILITY_SUCCESS = 'REMOVE_CONFLICTED_AVAILABILITY_SUCCESS';
export const REMOVE_CONFLICTED_AVAILABILITY_FAILURE = 'REMOVE_CONFLICTED_AVAILABILITY_FAILURE';

// Get Availabilities

export const GET_AVAILABILITIES_REQUEST = 'GET_AVAILABILITIES_REQUEST';
export const GET_AVAILABILITIES_SUCCESS = 'GET_AVAILABILITIES_SUCCESS';
export const GET_AVAILABILITIES_FAILURE = 'GET_AVAILABILITIES_FAILURE';

export const REMOVE_EXISTING_AVAILABILITY_REQUEST = 'REMOVE_EXISTING_AVAILABILITY_REQUEST';
export const REMOVE_EXISTING_AVAILABILITY_SUCCESS = 'REMOVE_EXISTING_AVAILABILITY_SUCCESS';
export const REMOVE_EXISTING_AVAILABILITY_FAILURE = 'REMOVE_EXISTING_AVAILABILITY_FAILURE';

// Get Availabilities Logs

export const GET_AVAILABILITIES_LOGS_REQUEST = 'GET_AVAILABILITIES_LOGS_REQUEST';
export const GET_AVAILABILITIES_LOGS_SUCCESS = 'GET_AVAILABILITIES_LOGS_SUCCESS';
export const GET_AVAILABILITIES_LOGS_FAILURE = 'GET_AVAILABILITIES_LOGS_FAILURE';
export const GET_AVAILABILITIES_LOGS_RESET = 'GET_AVAILABILITIES_LOGS_RESET';